
seedWebServices.service('DocService', ['$http', '$cacheFactory', '$uibModal', 'TranslationService', 'ToastService', '$window','$timeout',
    function ($http, $cacheFactory, $uibModal, TranslationService, ToastService, $window, $timeout) {

        var ctrl = this;
        var serviceCache = $cacheFactory('DocService');
        var URL = '../Api/Doc/';

        this.resetCache = function () {
            serviceCache.removeAll();
        };

        this.getDocTypes = function (filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + 'DocTypes',
                { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
                { cache: serviceCache }
            );
        };

        
        this.getDocType = function (docTypeID) {
            return $http.get(URL + 'DocType', {
                params: { docTypeID: docTypeID }
            });
        };

        this.saveDocType = function (docType) {
            return $http.post(URL + 'DocType', { docType: docType });
        };

        this.updateDocType = function (docType) {
            return $http.put(URL + 'DocType', { docType: docType });
        };

        this.deleteDocType = function (docTypeID) {
            return $http.delete(URL + 'DocType', {
                params: { docTypeID: docTypeID }
            });
        };

        this.getFtpSettings = function () {
            var cache = serviceCache;
            return $http.put(URL + 'GetFtpSettings',
                { cache: cache });
        };

        this.getFtpFiles = function (folder) {
            //var cache = serviceCache;
            return $http.put(URL + 'GetFtpFiles',
                { folder: folder },
                { cache: serviceCache });
        };

        this.getFtpFile = function (filePath) {
            return $http.get(URL + 'GetFtpFile', {
                responseType: "arraybuffer",
                params: { filePath: filePath }
            });
        };

        this.getOrderFiles = function (orderID) {
            return $http.put(URL + 'GetOrderFiles',
                { orderID: orderID },
                { cache: serviceCache });
        };

        this.getIssueFiles = function (orderID) {
            return $http.put(URL + 'GetIssueFiles',
                { orderID: orderID },
                { cache: serviceCache });
        };

        this.getFileExtension = function (fileName) {
            if (fileName) {
                return fileName.split('.').pop().toUpperCase();
            }
            else {
                return 'xxx';
            }
        };

        this.showDrawing = function (scope, drawingID) {
            console.log('docService.showDrawing ' + drawingID);

            drawingID = drawingID.padStart(5, '0');
            var fileName = drawingID + '.PNG';
            var absolutePath = 'ftp://45.235.247.2:2122/IMAGENS-SKU/' + fileName;
            
            ctrl.showFile(scope, fileName, absolutePath);
        };

        this.downloadFile = function (scope, file) {

        };

        this.showFile = function (scope, fileName, absolutePath, isDownload) {
            console.log('docService.showFile');

            scope.error = null;
            var toastID = ToastService.createToast('Baixando arquivo...', fileName, 0, 'wait');
            scope.downloading = true;
            this.getFtpFile(absolutePath).then(function (result) {
                scope.downloading = false;
                ToastService.removeToast(toastID);

                var fileType = "application/pdf";
                var fileExt = ctrl.getFileExtension(fileName);
                if (fileExt == 'PNG') {
                    fileType = 'image/png'
                }
                else if (fileExt == 'JPG') {
                    fileType = 'image/jpeg';
                }
                else if (fileExt == 'XLSX' || fileExt == 'XLS') {
                    fileType = 'application/vnd.ms-excel';
                }

                var blob = new Blob([result.data], { type: fileType });
                var objectUrl = $window.URL.createObjectURL(blob);
                //var fileName = file.Name;
                if (navigator.msSaveBlob) {
                    return navigator.msSaveBlob(blob, fileName);
                }
                var pdf = document.createElement('a');
                pdf.href = objectUrl;                            

                if (isDownload) {
                    pdf.download = fileName; // Add the 'download' attribute
                    // Simulate a click on the link to trigger the download
                    pdf.dispatchEvent(new MouseEvent('click'));

                    $timeout(function () {
                        // Cleanup the object URL after some time
                        $window.URL.revokeObjectURL(objectUrl);
                    }, 1000);
                }
                else {
                    var newWin = $window.open(objectUrl, '_blank');
                    $timeout(function () {
                        newWin.document.title = fileName;
                    }, 500);
                }
            },
                function (err) {
                    scope.downloading = false;
                    //console.log('Error');
                    //console.log(err);
                    scope.error = err;
                    var errMsg = '';
                    if (err.status == 500) {
                        errMsg = '500 - File Not Found: ' + fileName
                    }
                    else if (err.data && err.data.ExceptionMessage) {
                        errMsg = err.data.ExceptionMessage;
                    }
                    scope.errMsg = errMsg;
                    ToastService.updateToast(toastID, 'Erro!', errMsg, 2000, 'error');
                }
            );
        };


        this.getOrderDocs = function (orderID)
        {
            return $http.get(URL + 'GetOrderDocs',
                {
                    params: { orderID: orderID }
                }
            );
        };

        this.recreateOrderDocs = function (orderID, files) {
            return $http.put(URL + 'RecreateOrderDocs',
                {
                    orderID: orderID,
                    files: files
                },
                { cache: serviceCache }
            );
        };

        this.recreateSelectedOrderDocs = function (orders) {
            return $http.put(URL + 'RecreateSelectedOrderDocs',
                {
                    orders: orders,
                },
                { cache: serviceCache }
            );
        };

}]);